import api from "./";

interface IUsers {
  name: string;
  cpf: string;
  password: string;
  password_confirmation: string;
}

export const createNewUser = async (data: IUsers) => {
  return api.post("/api/v1/users", data).catch(() => {
    console.error("Usuário ou Senha inválido.");
  });
};

export const getUsers = async () => {
  const token = localStorage.getItem("uniservice_token");
  try {
    const response = await api.get("/api/v1/users", {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Ocorreu um erro ao carregar lista de usuários.", error);
  }
};
export const deleteUser = async (id: number) => {
  const token = localStorage.getItem("uniservice_token");
  const url = `/api/v1/users/${id}`;

  try {
    const response = await api.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Erro ao excluir usuário.", error);
  }
};
